<script setup>
import ModalView from '@/components/common/ModalView.vue'
import { ref, computed, watchEffect } from 'vue'
import UserIcon from '@/assets/icons/outline/UserIcon.vue'
import IconButtonComponent from '@/components/common/IconButtonComponent.vue'
import ButtonComponent from '@/components/common/ButtonComponent.vue'
import { useAuth0 } from '@auth0/auth0-vue'
import ArrowRightStartOnRectangle from '@/assets/icons/outline/ArrowRightStartOnRectangle.vue'
import TrashIcon from '@/assets/icons/outline/TrashIcon.vue'
import ClickToEditTextInputComponent from '@/components/common/ClickToEditTextInputComponent.vue'
const { logout, getAccessTokenSilently } = useAuth0()
import { useUserStore } from '@/stores/user'
import { useRoomStore } from '@/stores/room'
const userProfileModalOpen = ref(false)

const userStore = useUserStore()
const roomStore = useRoomStore()
const { isAuthenticated } = useAuth0()

const deleteAccount = async () => {
    alert('Deleting an account is not yet supported')
}

const username = ref(userStore.name)

watchEffect(() => {
    username.value = userStore.name
})

const hasChanges = computed(() => {
    return username?.value?.trim() !== userStore?.name?.trim()
})

const onUsernameChange = (event) => {
    username.value = event
}

const onSave = async () => {
    const token = await getAccessTokenSilently()
    await fetch(`${import.meta.env.VITE_BACKEND_BASE_URL}/users/profile`, {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            nickname: username.value.trim()
        })
    })

    await userStore.retrieveProfile()
    roomStore.updateUserInPresence()
    userProfileModalOpen.value = false
}

</script>

<template>
    <IconButtonComponent v-if="isAuthenticated" @click="userProfileModalOpen = true">
        <UserIcon />
    </IconButtonComponent>

    <Teleport v-if="userProfileModalOpen" to="#modal-root">
        <ModalView label="Profile" @close="userProfileModalOpen = false">
            <div class="flex flex-col h-full">
                <div class="flex flex-col h-full w-full divide-y divide-primary">
                    <div class="flex flex-row justify-between px-4 py-4">
                        <div class="font-bold">Email</div>
                        <div>{{ userStore.email }}</div>
                    </div>
                    <div class="flex flex-row justify-between px-4 py-4">
                        <div class="font-bold">Name</div>
                        <ClickToEditTextInputComponent v-model="username" :value="userStore.name"
                            @change="onUsernameChange" :style="'text-neutral ml-2 p-0'" />
                    </div>
                </div>
                <div class="flex flex-row justify-end w-full gap-4">
                    <ButtonComponent @click="onSave" :disabled="!hasChanges">
                        Save
                    </ButtonComponent>
                    <IconButtonComponent @click="logout">
                        <ArrowRightStartOnRectangle />
                    </IconButtonComponent>
                    <IconButtonComponent @click="deleteAccount">
                        <TrashIcon />
                    </IconButtonComponent>
                </div>
            </div>
        </ModalView>
    </Teleport>
</template>